import { create } from 'zustand';
import { ApiService } from './ApiService';

export enum FeatureType {
  USE_NEW_LOGIN_PAGE = 'USE_NEW_LOGIN_PAGE',
  USE_WELFARE_AREA_CHECKING = 'USE_WELFARE_AREA_CHECKING',
  USE_SLAUGHTER_PREPARATION_ANIMALS = 'USE_SLAUGHTER_PREPARATION_ANIMALS',
  USE_COMPARE_FUNCTIONALITY = 'USE_COMPARE_FUNCTIONALITY',
  USE_CULTURE_NAMES = 'USE_CULTURE_NAMES',
  SEARCH_BY_CLIMATE = 'SEARCH_BY_CLIMATE',
  USE_SLAUGHTERHOUSE_MANAGEMENT = 'USE_SLAUGHTERHOUSE_MANAGEMENT',
  VIEW_SLAUGHTER_IMPORT_HISTORY = 'VIEW_SLAUGHTER_IMPORT_HISTORY',
  USE_TASK_OCCURRENCE_UPDATE = 'USE_TASK_OCCURRENCE_UPDATE',
  VIEW_SILO = 'VIEW_SILO',
  USE_EXTERNAL_PROVIDER = 'USE_EXTERNAL_PROVIDER',
  USE_READER_HEALTH_WIDGET = 'USE_READER_HEALTH_WIDGET',
  USE_PASSWORD_POLICY = 'USE_PASSWORD_POLICY',
  USE_LUNG_WEATHER_RULE = 'USE_LUNG_WEATHER_RULE',
  USE_MEDICATION_CATALOGUE = 'USE_MEDICATION_CATALOGUE'
}

interface FeaturesState {
  features: Record<string, boolean>;
  isInitialized: boolean;
  initialize: () => Promise<void>;
  hasFeature: (feature: FeatureType) => boolean;
}

export const useFeatures = create<FeaturesState>((set, get) => ({
  features: {},
  isInitialized: false,
  initialize: async () => {
    if (get().isInitialized) {
      return;
    }

    try {
      const apiService = new ApiService();
      const response = await apiService.api.admin.adminGetFeatures();

      const data = response?.data ?? {};
      if (typeof data !== 'object' || data === null) {
        console.warn('Invalid feature data received:', data);
      }

      set({
        features: data && typeof data === 'object' ? data : {},
        isInitialized: true
      });
    } catch (error) {
      console.error('Failed to initialize features:', error);
      set({ features: {}, isInitialized: true });
    }
  },

  hasFeature: (feature: FeatureType) => {
    const state = get();

    if (!state.features || typeof state.features !== 'object') {
      return false;
    }

    return Boolean(state.features[feature]);
  }
}));

// Initialize features on import
useFeatures.getState().initialize().catch(console.error);

export default useFeatures;
